import { useEffect } from 'react';

export default function useOutsideClick(ref, handler) {
  useEffect(() => {
    function handleClick(event) {
      if (!ref.current) return;

      if (!ref.current.contains(event.target)) {
        handler();
      }
    }

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [ref, handler]);
}
